export const addFollowup_style = {
  commonTextColorSx: {
    color: '#007965',
    fontSize: '13px',
  },
};
